
<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="NAME.SINGULAR"></span></label> -->
          <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                #focusElement
                [MaxLength]="100"                
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'PROVAJDER.NAZIV.SINGULAR'">
              </yt-input>
          </div> 
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtUrl"
              formControlName="Url"
              #focusElement
              [MaxLength]="100"                
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
              [Label]="'PROVAJDER.URL.SINGULAR'">
            </yt-input>
        </div> 
        <div class="col-md-12">
          <yt-input
            [Type]="'text'"
            name="txtGenericName"
            formControlName="GenericName"
            #focusElement
            [MaxLength]="100"                
            [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
            [Label]="'PROVAJDER.GENERICNAME.SINGULAR'">
          </yt-input>
      </div>            
        </div>
      </div>
    </div>
  </div>
</form>
